
import PartSearch from './part-search';
import PartSearchCart from './part-search-cart';

let part_search_cart = new PartSearchCart('part-search-cart');
let part_search = new PartSearch('part-search');



// WEBPACK FOOTER //
// ./js/app.js